<template>
  <div class="home">
    <MapCreator />
  </div>
</template>

<script>
// @ is an alias to /src
import MapCreator from '@/components/MapCreator.vue'

export default {
  name: 'Home',
  components: {
    MapCreator,
  }
}
</script>
